export default __webpack_public_path__ + "static/media/Sage's Gloves of the Purple Sun.595ca5a2.jpg";